import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class BuildingStylesService {

  constructor(private http: HttpClient) { }

  getData(postData: any, page: any, perPage?: number): Observable<any[]> {
    return this.http.post<any[]>(`${environment.yiiUrl}building-styles/search?expand=agency_data&get_all=true&page=` +
      page + `&per-page=${perPage}`, postData, { observe: 'response' as 'body' })
      .pipe(map(data => {
        return data;
      }));

  }

  createData(data: any): Observable<object> {
    return this.http.post(`${environment.yiiUrl}building-styles`, data);
  }

  updateData(data: any): Observable<object> {
    return this.http.put(`${environment.yiiUrl}building-styles/${data._id}`, data);
  }

  deleteData(_id: any, createdBy: any): Observable<any> {
    return this.http.delete(`${environment.yiiUrl}building-styles/${_id}?created_by=${createdBy}`);
  }
  getCommercialStyles(postData: any, page: any, perPage?: number): Observable<any[]> {
    return this.http.post<any[]>(`${environment.yiiUrl}building-styles/search?expand=agency_data&for=commercial&get_all=true&page=` +
      page + `&per-page=${perPage}`, postData, { observe: 'response' as 'body' })
      .pipe(map(data => {
        return data;
      }));
  }

  getModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/get-exclusions?model=building_style`);
  }

  updateModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-exclusions`, data);
  }

  getAllModel(): Observable<object> {
    return this.http.get<any>(`${environment.yiiUrl}agencies/is-all-check?model=building_style`);
  }

  updateAllModel(data: any): Observable<object> {
    return this.http.post<any>(`${environment.yiiUrl}agencies/model-all-exclusions`, data);
  }
}
